// extracted by mini-css-extract-plugin
module.exports = {"dot":"ProfileBattingSummary_dot_sZ5pu","table":"ProfileBattingSummary_table_3VZUl"};